import React, { useEffect, useLayoutEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  BrowserRouter,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.css";
import Home from "./components/Home";
import logo from "./logo.svg";
import "./App.css";
import ScrollToTop from "./components/smallComponents/scrollTop";
import About from "./components/About";
import Services from "./components/Services";
import Bookings from "./components/Bookings";

function App() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/bookings" element={<Bookings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
